









































































import { NdObjednavkaZakazka } from '@/modules/sklad/ndObjednavka/ndObjednavkaZakazka';
import { openList } from '@/main/router/routerPath';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { ListLoadBehavior, mapActionsDvm } from '@/main/pages';
import { getStavZakazka } from '@/modules/servis/zakazka/utils';
import { apiProvider } from '@/modules/servis/zakazka/api';
import { END_LOADING, START_LOADING } from '@/main/store/listEditTypes';

import { UserRole } from '@/main/components/constants';

import { DmsBaseComponent } from '#components/dms/common/base';
import DmsBadgeButton from '#components/dms/button/BadgeButton.vue';

import { ORDER_SUB_TYPES, ZAKAZKA_DRUH, ZAKAZKA_STAV, ZAKAZKANDREZ } from '../constants';
import { JednotnaFrontaNd } from '../../jednotnaFrontaNd';
import { ServisniPakety } from '../servisniPakety';
import { store } from '../store/edit';
import { isUserPartsManager, getTableCount } from '@/main/utils/commonFunctions';

export default DmsBaseComponent.extend({
	name: 'Buttons',
	components: {
		DmsBadgeButton,
	},
	props: {
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			textDialog: '',
			dialogLableText: '',
			ZAKAZKA_DRUH,
			isDialogVisible: false,
			approvalDialogText: '',
			showCertifikatTiskDialog: false,
			showDiscountDialog: false,
			disabledDruhySubsets: {
				Dilenska: new Set([
					ZAKAZKA_DRUH.PRODEJ_PULT,
					ZAKAZKA_DRUH.PREVOD_ND,
					ZAKAZKA_DRUH.INTERNI_PRODEJ,
					ZAKAZKA_DRUH.ZAPUJCKA,
					ZAKAZKA_DRUH.DROBNE_SLUZBY,
					ZAKAZKA_DRUH.ZPETNY_ODKUP_ND,
				]),
				ZakazkovyList: new Set([
					ZAKAZKA_DRUH.DILENSKA,
					ZAKAZKA_DRUH.GARANCE,
					ZAKAZKA_DRUH.KULANCE,
					ZAKAZKA_DRUH.MONTAZ_DV,
					ZAKAZKA_DRUH.INTERNI_DILENSKA,
					ZAKAZKA_DRUH.UDRZBA_OV,
				]),
				DZM: new Set([ZAKAZKA_DRUH.DILENSKA, ZAKAZKA_DRUH.KULANCE, ZAKAZKA_DRUH.INTERNI_DILENSKA]),
				TiskPneu: new Set([ZAKAZKA_DRUH.DROBNE_SLUZBY, ZAKAZKA_DRUH.DILENSKA, ZAKAZKA_DRUH.INTERNI_DILENSKA, ZAKAZKA_DRUH.MONTAZ_DV]),
				Zapujcky: new Set([ZAKAZKA_DRUH.DILENSKA, ZAKAZKA_DRUH.KULANCE, ZAKAZKA_DRUH.INTERNI_DILENSKA]),
				ZAKAZKA_DRUH, // TODO: tento set neexistoval
			},
			carDes: {
				visible: false,
				label: '',
				html: '',
			},
		};
	},
	computed: {
		...genVuexComputeds(store),
		zakazkaExists(): boolean {
			return this.ZakazkaId! > 0;
		},
		isReservationDisabled(): boolean {
			if ((this.IsWatchlisted && this.loggedUser.DmsSys.WatchlistedApprovalPrp) || this.isReservationNotAllowed) {
				return true;
			}
			if(getStavZakazka(this.edit) === ZAKAZKA_STAV.NABIDKA){
				return true;
			}
			return false;
		},
		isItemDisabled(): boolean {
			if(getStavZakazka(this.edit) === ZAKAZKA_STAV.NABIDKA) {
                return true;
            }
			return getStavZakazka(this.edit) === ZAKAZKA_STAV.UZAVRENA;
		},
		isPrevodNdDruh(): boolean {
			return this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND;
		},
		isZakazkovyListDisabled(): boolean {
			if (this.EnableJoblist === true) {
				return true;
			}
			if (this.ZakazkaDruh === ZAKAZKA_DRUH.MONTAZ_DV) {
				return this.PnvId === null || this.NvskladId === null;
			}
			return this.ZakaznikId === null || this.VozidloId === null || (this.isViewMode && !this.ZakazkaListId);
		},
		discountDdialogLableText(): string {
			return this.LocalizePopisostatni('ApplyDiscount');
		},
		campaingDisabled(): boolean {
			return (
				getTableCount(this.dependentTables?.ZakazkaNd, this.PartsCount) > 0
					|| getTableCount(this.dependentTables?.ZakazkaPracovniPozice, this.LaborsCount) > 0
			);
		},
		isUserPartsManager(): boolean {
			const isPartsManager = isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
            return isPartsManager;
		},
		isParitalInvoiceGenerated(): boolean {
			return (this.IsPartialInvoiced && getStavZakazka(this.edit) === ZAKAZKA_STAV.UVOLNENA) ?? false;
		},
		isOEMPartyBilled(): boolean {
			return (this.IsOEMPartyBilled && getStavZakazka(this.edit) === ZAKAZKA_STAV.UVOLNENA) ?? false;
		},
		isReservationNotAllowed(): boolean {
			return ((this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA)
				&& getStavZakazka(this.edit) === ZAKAZKA_STAV.UZAVRENA);
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
		allowButton(buttonName: string): boolean {
			switch (buttonName) {
				case 'zaplanovani':
				case 'ZL':
					return (
						this.disabledDruhySubsets.ZakazkovyList.has(this.ZakazkaDruh!)
						&& this.dmsSys.DZMKontrola === 2
						&& getStavZakazka(this.edit) !== ZAKAZKA_STAV.NABIDKA
					);
				case 'DZM':
					return this.disabledDruhySubsets.DZM.has(this.ZakazkaDruh!) && this.dmsSys.DZMKontrola === 2;
				case 'elsaPro':
				case 'tiskMechanik':
					return !this.disabledDruhySubsets.Dilenska.has(this.ZakazkaDruh!);
				case 'certSpecOpr':
				case 'specOpravNeh':
					// TODO: the visibility of this button will in the future be handled by data received from special endpoint
					// - http://tsczbntfs:8080/tfs/DMS/DMS3/DMS3%20Team/_workitems?id=5540&_a=edit&triage=false
					return this.ZakazkaDruh! === ZAKAZKA_DRUH.DILENSKA;
				case 'zapujcky':
					return this.disabledDruhySubsets.Zapujcky.has(this.ZakazkaDruh!);
				case 'pneuSklad':
				case 'tiskPneu':
					return this.disabledDruhySubsets.TiskPneu.has(this.ZakazkaDruh!);
				case 'KD':
					return [ZAKAZKA_DRUH.DILENSKA, ZAKAZKA_DRUH.INTERNI_DILENSKA, ZAKAZKA_DRUH.UDRZBA_OV].includes(this.ZakazkaDruh!);
				case 'GatePass':
					return this.ZakazkaDruh! === ZAKAZKA_DRUH.DILENSKA && this.ShowGatepassButton! && this.dmsSys.GatePassPrp!;
				case 'DeliveryNote':
					return this.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_PULT && this.ShowGatepassButton! && this.dmsSys.GatePassPrp!;
				case 'Campaign':
					return this.VozidloId !== null && this.OrderSubtypeId !== ORDER_SUB_TYPES.PDI_V
					&& (this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA);
				default:
					return false;
			}
		},
		async onRezervacendClick() {
			while (this.dropdownList.DefaultPartsList.length <= 0 && this.DefaultWarehouseId == null) {
				this.loading = true;
			}
			this.loading = false;
			if (this.dmsSys.WorkItemPrp && this.IsAllItemLevelStatusEntered) {
				const areAllItemsCompleted = !await this.showConfirmMessage('IsAllItemCompleted');
				if (areAllItemsCompleted) return;
			}
			openList(ZAKAZKANDREZ, {
				filter: {
					ZakazkaId: this.ZakazkaId,
					OrderStatus: getStavZakazka(this.edit),
					DefaultWarehouseId: this.DefaultWarehouseId,
					IsDNPVisible: this.IsDNPVisible,
					WorkShopId: this.ProvozovnaId,
					OrderNo: this.ZakazkaNr			
				},
				partsListData: this.dropdownList.DefaultPartsList,
				IsDNPVisible: this.IsDNPVisible,
				CanAddPartOrLabour: this.CanAddPartOrLabour,
				IsWorkshopContractOrder: this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA,
			}, { ZakazkaId: this.ZakazkaId, OrderStatus: getStavZakazka(this.edit), DefaultWarehouseId: this.DefaultWarehouseId, IsDNPVisible: this.IsDNPVisible, WorkShopId: this.ProvozovnaId, OrderNo: this.ZakazkaNr, ZakaznikId: this.ZakaznikId, ZakazkaDruh: this.ZakazkaDruh, CanAddPartOrLabour: this.CanAddPartOrLabour});
		},
		onObjednavkyClick() {
			openList(NdObjednavkaZakazka.name, { filter: { ZakazkaId: this.ZakazkaId } });
		},
		onJednotnaFrontaNdClick() {
			 openList(JednotnaFrontaNd.name, {
				filter: {
					ZakazkaId: this.ZakazkaId,
					PracovnikId: this.PracovnikId,
					PracovnikIdText: this.PracovnikIdText,
					PracovnikOsobniCis: this.PracovnikOsobniCis,
					NabidkaPrp: this.NabidkaPrp,
					ZakaznikId: this.ZakaznikId,
					VozidloId: this.VozidloId,
				},
			});
		},
		onServisniPaketyClick() {
			if (this.dmsSys.EnableTaiwanPrp) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('FunctionDisabled'),
					options: { type: 'error' },
				});
			} else {
				openList(ServisniPakety.name, { filter: { ZakazkaId: this.ZakazkaId } });
			}
		},
		async onDMZClick() {
			const { data: DZMdata } = await this.getDMZ();
			if (DZMdata.KmStav < 0) {
				this.isDialogVisible = true;
				this.dialogLableText = this.LocalizePopisostatni('lblNadpDzm');
				this.textDialog = this.LocalizeChyboveHlasky('DZMNoZL');
			} else if (DZMdata.DmzPP) {
				this.isDialogVisible = true;
				this.dialogLableText = this.LocalizePopisostatni('lblNadpDzm');
				this.textDialog = this.LocalizeChyboveHlasky('DZMNoPP');
			} else {
				window.open(DZMdata.Url, '_blank');
			}
		},
		onElsaLink() {
			window.open(this.getDmsSysValue('PortalElsaProApp_url', null) as string, '_blank');
		},
		async toggleDiscountDialog() {
			this.showDiscountDialog = !this.showDiscountDialog;
		},
		async updateDiscount() {
			this.showDiscountDialog = false;
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			await apiProvider.updateDiscount(this.ZakazkaId, this.TotDiscPercent, this.TotDiscVal);
			this.CenaCelkem = (await apiProvider.getPrice(this.ZakazkaId!)).data;
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},
		async saveDiscount() {
			if (this.TotDiscVal! > this.CenaCelkem!) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('DiscountCannotBeLarger'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return;
			}
			const checkforDiscount = await this.checkForDiscountLimit();
			if (checkforDiscount) {
				this.updateDiscount();
			}
		},
		async onDiscountChange() {
			if (this.VyrobekvozOzn !== 'C' && (this.TotDiscPercent !== null && this.TotDiscVal !== null)) {
				this.showErrorAlert({ message: 'anyOneTypeDiscountAllowed' });
				this.TotDiscPercent = null;
				this.TotDiscVal = null;
			} else if (this.VyrobekvozOzn === 'C' && (this.TotDiscPercent !== null && this.TotDiscVal !== null)) {
				const isValid = await this.showConfirmPokracovat(`${this.LocalizeChyboveHlasky('bothDiscountMessage')}`, false);
				if (!isValid) {
					this.TotDiscPercent = null;
					this.TotDiscVal = null;
				} else {
					this.showDiscountDialog = false;
					this.saveDiscount();
				}
			}
		},
		checkForDiscountLimit() {
			if (!this.dmsSys.OrderDiscountPrp) return true;
			let errormsg = null;
			if (this.loggedUser.DiscountLimitConfigData === null) errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			else {
				errormsg = this.validateDiscount(this.loggedUser.DiscountLimitConfigData.OrderTotalVal, this.loggedUser.DiscountLimitConfigData.OrderTotalPer);
			}
			if (errormsg !== null) {
				this.showErrorAlert({
					title: '',
					message: `${errormsg}  ${this.LocalizePopisostatni('ORDER_TOTAL_STR')}`,
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			return true;
		},
		validateDiscount(discountval: number, discountper: number) {
			let errormsg = null;
			if (discountval === 0 && (discountper === 0 || this.loggedUser.DiscountLimitConfigData === null)) {
				errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			} else if (this.TotDiscPercent === null && this.TotDiscVal === null) {
				errormsg = this.LocalizeChyboveHlasky('msgReqDiscOrValue');
			} else if (discountval > 0 && discountper > 0 && discountval < (this.TotDiscVal === null ? 0 : this.TotDiscVal)
					&& discountper < (this.TotDiscPercent === null ? 0 : this.TotDiscPercent)) {
				errormsg = (this.LocalizeChyboveHlasky('msgNotMoreThnDiscValNPer').replace('<DISC_VAL>', discountval.toString()).replace('<DISC_PER>', discountper.toString()));
			} else if (discountval > 0 && discountval < (this.TotDiscVal === null ? 0 : this.TotDiscVal)) {
				errormsg = this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscVal').replace('<DISC_VAL>', discountval.toString());
			} else if (discountper > 0 && discountper < (this.TotDiscPercent === null ? 0 : this.TotDiscPercent)) {
				errormsg = this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer').replace('<DISC_PER>', `${discountper}%`);
			} else if (discountval > 0 && this.TotDiscVal! > discountval) {
				errormsg = this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscVal').replace('<DISC_VAL>', `${discountval}`);
			}
			return errormsg;
		},
		async showConfirmMessage(message: string) {
			return this.showConfirm({
				message: this.LocalizeChyboveHlasky(message),
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});
		},
	},
});
